export const EditGridColumnType = {
    INPUT: 1,
    DROPDOWN: 2,
    NUMERIC: 3,
    DATEPICKER: 4,
    CHECKBOX: 5,
    // other types
    ACTION: 10,
}
